import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useBlockContext } from './BlockContext';
import { ParameterTemplate } from './ParameterTemplate';
import { useContracts } from './useContracts';
export function BlockConnector(props) {
  return /*#__PURE__*/React.createElement(PiralBlockAdapter, props);
}
export function PiralBlockAdapter(_ref) {
  var block = _ref.block,
    contractData = _ref.contractData;
  var _useBlockContext = useBlockContext(),
    piletApi = _useBlockContext.piletApi,
    view = _useBlockContext.view,
    allViews = _useBlockContext.allViews,
    changeView = _useBlockContext.changeView;
  var mergedContracts = useContracts(contractData);
  var templatedBlockParameters = React.useMemo(function () {
    return ParameterTemplate.replace.apply(ParameterTemplate, [block.blockParameters].concat(_toConsumableArray(mergedContracts)));
  }, [block.blockParameters, mergedContracts]);
  var extensionParams = _objectSpread({
    view: view,
    blockRID: block.blockRID,
    allViews: allViews,
    changeView: changeView,
    contractSources: mergedContracts,
    paramSources: mergedContracts
  }, templatedBlockParameters);
  return /*#__PURE__*/React.createElement(piletApi.Extension, {
    name: block.blockName,
    params: extensionParams
  });
}